export class MatchedLeadsProductAtsDto {
    ebeIntegrationUrl: string;
    tenstreetReferrer: string;
    tenstreetCompanyId: string;
    tenstreetSourceOverride: string;
    avatarFleetUrl: string;
    driverReachPublicApiKey: string;
    driverReachSecretApiKey: string;
    truckRightApiAccessKey: string;
    truckRightApiSecretAccessKey: string;
    truckRightApiPostingUrl: string;
    jobcastAuthenticationKey: string;
    jobcastPassword: string;
    ebeJobRequisitionId: string;
    jobcastReferenceId: string;
    driverReachLeadSourceOverride: string;
    rmwUrl: string;
    rmwPageUrl: string;
    rmwSource: string;
    tenstreetJobPostingReferenceId: string;
    uploadAcquireCsv: boolean;
    cdaiJobRequisitionId: string;
    doubleNickelCompanyId: string;
    doubleNickelTrackingLinkId: string;
    theTruckerCompanyId: string;
    theTruckerApiToken: string;
}